module.exports = __webpack_public_path__ + "static/media/judge-active.0433f347.png";